import React from 'react'
import { IconProps } from '../../types'
import { concatClassName } from '../../utils/helpers'

export const InvestIconHIW_v0 = ({ width = '100', height = '100', classes }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 400 300'
    className={concatClassName(classes)}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='210.5' cy='123.5' r='123.5' fill='#FFEFEF' />
    <rect
      x='2.46325'
      y='66.7828'
      width='247.041'
      height='147.829'
      rx='13.2847'
      stroke='#464646'
      strokeWidth='4.9265'
    />
    <path
      d='M193.359 310.762V148.411H228.829V310.762L215.083 281.425C213.499 278.044 208.689 278.044 207.105 281.425L193.359 310.762Z'
      fill='white'
      stroke='#464646'
      strokeWidth='4.9265'
    />
    <path
      d='M221.932 148.411H253.462V246.388L241.33 228.707C239.58 226.156 235.815 226.156 234.065 228.707L236.096 230.1L234.065 228.707L221.932 246.388V148.411Z'
      fill='white'
      stroke='#464646'
      strokeWidth='4.9265'
    />
    <circle
      cx='223.754'
      cy='108.85'
      r='59.9538'
      fill='white'
      stroke='#464646'
      strokeWidth='4.9265'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeDasharray='7.77 15.54 23.31 31.08'
    />
    <circle
      cx='223.559'
      cy='109.044'
      r='34.2452'
      fill='white'
      stroke='#464646'
      strokeWidth='4.9265'
    />
    <path
      d='M43.3069 109.989L120.472 110.382'
      stroke='#464646'
      strokeWidth='4.72439'
      strokeLinecap='round'
    />
    <path
      d='M43.3069 130.461L120.472 130.855'
      stroke='#464646'
      strokeWidth='4.72439'
      strokeLinecap='round'
    />
    <path
      d='M43.3069 150.933L120.472 151.327'
      stroke='#464646'
      strokeWidth='4.72439'
      strokeLinecap='round'
    />
    <path
      d='M39.7636 195.421C50.6559 194.765 70.787 190.382 64.1729 178.099C55.9052 162.744 31.8896 166.681 39.7636 178.099C47.6375 189.516 74.4091 194.634 79.9208 186.366C85.4326 178.099 79.9208 177.311 94.4877 186.366C109.055 195.421 108.267 186.366 114.96 186.366C120.314 186.366 130.314 186.366 134.645 186.366'
      stroke='#464646'
      strokeWidth='3.93699'
      strokeLinecap='round'
    />
  </svg>
)

export const InvestIconHIW = ({ width = '100', height = '100' }: IconProps) => (
  <svg
    width={width}
    height={height}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 5 130 120'
  >
    {' '}
    <path
      d='M70 125C103.137 125 130 98.1371 130 65C130 31.8629 103.137 5 70 5C36.8629 5 10 31.8629 10 65C10 98.1371 36.8629 125 70 125Z'
      fill='#EEFBFF'
    ></path>{' '}
    <path
      d='M95.9204 40.1005C93.7455 33.8859 89.3524 29.3052 83.2159 26.8545C78.0237 24.7808 71.8835 24.4282 66.3692 25.8875C62.5154 26.9072 59.3379 28.7014 57.1802 31.0754C54.7433 33.757 53.7877 36.9948 54.4167 40.4363C54.4747 40.7568 54.5421 41.0708 54.6163 41.3792C53.7095 42.3032 52.9255 43.2614 52.1879 44.2271C51.4502 43.2612 50.666 42.3028 49.759 41.3788C49.8332 41.0711 49.9006 40.7578 49.9588 40.438C50.587 36.9935 49.63 33.7552 47.1908 31.0733C45.0314 28.6987 41.852 26.9051 37.9964 25.8858C32.4824 24.4286 26.3435 24.7822 21.1531 26.856C15.0193 29.3071 10.6285 33.8872 8.45547 40.1009C8.26962 40.6322 8.41618 41.2232 8.82869 41.6064C9.2412 41.9895 9.84145 42.0916 10.3577 41.8676C18.3222 38.4042 22.6902 41.6264 26.9146 44.7425C27.0992 44.8787 27.2828 45.0141 27.4656 45.1482C32.7315 49.0074 36.792 50.1845 39.7863 50.1845C41.2489 50.1845 42.4575 49.9034 43.4274 49.517C45.6796 48.6194 47.494 46.824 48.6858 44.3923C49.4205 45.2465 50.0916 46.1412 50.7715 47.0633V54.797C45.3222 55.0735 40.178 56.9448 35.8168 60.2535C35.1935 60.7263 35.0717 61.6149 35.5444 62.2382C36.0174 62.8615 36.9059 62.9835 37.5292 62.5104C41.7691 59.2938 46.837 57.5934 52.1853 57.593C52.1862 57.593 52.1872 57.5932 52.1881 57.5932C52.1891 57.5932 52.19 57.593 52.191 57.593C65.5567 57.5949 76.43 68.437 76.43 81.7638C76.43 87.0888 74.7314 92.1194 71.5218 96.3417L55.9179 102.431C56.0099 101.038 55.8276 99.536 55.3698 98.0554C55.1172 97.2387 54.7867 96.4596 54.3906 95.726C57.9494 94.7446 60.0063 91.6689 60.4545 88.8186C61.0506 85.0291 59.0344 81.7334 55.3178 80.4222C54.6843 80.199 54.1171 79.9923 53.6041 79.798V70.4285C55.2663 70.7409 56.2837 71.6007 56.3381 71.6477C56.9061 72.1679 57.7881 72.1397 58.3212 71.5793C58.8604 71.0125 58.8379 70.1159 58.2711 69.5765C58.2513 69.5576 56.5064 67.9359 53.6041 67.5598V65.2954C53.6041 64.5129 52.9699 63.8788 52.1876 63.8788C51.4052 63.8788 50.771 64.5129 50.771 65.2954V67.6227C50.3481 67.6947 49.9231 67.7935 49.4987 67.9202C47.0401 68.6582 45.2021 70.7619 44.702 73.4103C44.2487 75.8113 45.0104 78.1207 46.6924 79.4393C47.6951 80.2218 49.0059 80.9529 50.771 81.7117V91.6092C50.6667 91.5359 50.5626 91.4625 50.4561 91.3926L46.1703 88.5819C42.5329 86.1971 35.5333 82.558 28.0245 83.693C27.9735 83.0518 27.945 82.4071 27.945 81.7638C27.945 76.2796 29.8379 70.9096 33.2753 66.643C33.7662 66.0337 33.67 65.1422 33.0609 64.6511C32.4514 64.1602 31.5597 64.256 31.069 64.8657C27.2274 69.6339 25.1118 75.6351 25.1118 81.7638C25.1118 82.6226 25.1564 83.4839 25.2376 84.338C24.9016 84.4445 24.568 84.5598 24.2398 84.6861L20.0894 86.2859V85.5481C20.0894 83.4408 18.3696 81.7264 16.2559 81.7264H1.41658C0.63425 81.7264 0 82.3605 0 83.143C0 83.9255 0.63425 84.5596 1.41658 84.5596H16.2557C16.8072 84.5596 17.256 85.003 17.256 85.5481V113.236C17.256 113.781 16.8072 114.225 16.2557 114.225H1.41658C0.63425 114.225 0 114.859 0 115.641C0 116.424 0.63425 117.058 1.41658 117.058H16.2557C18.3695 117.058 20.0892 115.344 20.0892 113.236V112.438C24.7771 112.538 26.0473 113.307 33.0373 117.543L33.2664 117.681C37.6922 120.362 40.7252 121.522 43.7349 121.686C43.9723 121.699 44.2084 121.705 44.4442 121.705C47.4817 121.705 50.3962 120.652 53.7762 119.08L68.0912 112.42C68.8006 112.09 69.1081 111.248 68.7782 110.538C68.448 109.829 67.6054 109.521 66.8962 109.851L52.5814 116.511C45.6666 119.726 42.4851 119.952 34.7342 115.258L34.5056 115.12C27.3519 110.784 25.6259 109.738 20.0892 109.606V89.3219L25.2576 87.3298C25.8613 87.0975 26.4849 86.9039 27.1154 86.7539C34.1728 85.0495 41.1099 88.6523 44.6164 90.951L48.9032 93.7622C52.8607 96.3521 53.7628 101.562 52.6675 104.158C52.1779 105.287 51.1967 106.064 49.9531 106.134C48.9613 106.189 47.9726 105.863 47.0901 105.436C46.7269 105.261 46.3741 105.062 46.0354 104.843L34.3099 97.2261C33.6542 96.7996 32.7766 96.9864 32.3503 97.6422C31.9242 98.2983 32.1105 99.1757 32.7666 99.6018L44.4931 107.219C47.0716 108.892 50.6352 109.814 53.3078 107.814C54.0129 107.286 54.5842 106.604 55.0009 105.829L77.8794 96.9016C81.0805 95.6531 82.892 96.7924 83.4711 98.1474C84.1785 99.8027 83.3782 102.184 80.4804 103.534L72.5872 107.206C71.878 107.536 71.5703 108.378 71.9003 109.087C72.2303 109.797 73.073 110.104 73.7823 109.774L81.6758 106.102C86.207 103.993 87.3195 99.9436 86.0763 97.0343C84.9149 94.3164 81.612 92.4048 76.8495 94.2626L76.0305 94.5821C78.1554 90.6726 79.2627 86.3137 79.2627 81.7638C79.2627 67.3479 67.8778 55.5344 53.6043 54.7967V47.0633C54.2841 46.1415 54.9548 45.2474 55.689 44.3939C56.8793 46.8234 58.6919 48.6175 60.9432 49.5156C61.9144 49.903 63.1236 50.1846 64.5887 50.1845C67.5837 50.1845 71.6453 49.0068 76.9107 45.1479C77.0946 45.013 77.2795 44.8766 77.4654 44.7395C81.6866 41.6255 86.0516 38.4051 94.0184 41.8678C94.5346 42.0922 95.1349 41.9896 95.5474 41.6062C95.9601 41.2228 96.1064 40.6318 95.9204 40.1005ZM42.3784 46.885C39.094 48.1944 34.5164 46.8028 29.1406 42.8632C28.9602 42.7308 28.7787 42.5971 28.5964 42.4624C25.5154 40.1898 21.9088 37.5291 16.7931 37.5291C15.4413 37.5291 13.9837 37.715 12.4032 38.1428C17.3537 28.9733 28.4636 26.297 37.2725 28.6247C42.3272 29.9608 47.8273 33.5151 47.2688 39.213C44.423 37.1219 40.4536 35.3704 34.2098 34.3594C33.4379 34.2328 32.7101 34.7589 32.5851 35.5312C32.4601 36.3035 32.9848 37.0309 33.7571 37.1561C40.252 38.2077 43.9278 40.0032 46.5369 42.231C45.6713 44.5023 44.2203 46.1508 42.3784 46.885ZM50.7708 78.6007C49.796 78.1291 49.0344 77.6731 48.4376 77.2075C47.5942 76.5464 47.2295 75.2927 47.4856 73.936C47.7231 72.6786 48.5904 71.151 50.3111 70.6344C50.4646 70.5885 50.618 70.5483 50.7708 70.5122V78.6007ZM53.604 92.9965V82.8185C53.8491 82.9071 54.1054 82.9987 54.3753 83.0937C57.9897 84.369 57.7999 87.4609 57.6556 88.3783C57.356 90.2829 55.9817 92.3381 53.604 92.9965ZM75.7836 42.4596C75.5998 42.5952 75.4174 42.7298 75.2359 42.8628C69.8584 46.8043 65.279 48.1944 61.9931 46.884C60.1518 46.1495 58.7021 44.5021 57.8382 42.232C60.4474 40.0036 64.1233 38.2079 70.6191 37.1561C71.3915 37.031 71.9162 36.3035 71.7911 35.5312C71.6661 34.7589 70.9382 34.2328 70.1664 34.3594C63.9225 35.3704 59.9531 37.1221 57.1071 39.2133C56.5459 33.5175 62.0422 29.9631 67.0941 28.6264C69.0792 28.1011 71.1801 27.8301 73.3022 27.8301C80.5989 27.8301 88.1349 31.0376 91.9727 38.1432C84.4095 36.0967 79.6762 39.5879 75.7836 42.4596Z'
      fill='#545A5E'
    ></path>{' '}
  </svg>
)

export const EarnIconHIW_v0 = ({ width = '100', height = '100', classes }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 400 300'
    className={concatClassName(classes)}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='227.5' cy='123.5' r='123.5' fill='#FFEFEF' />
    <rect
      x='212.202'
      y='152.538'
      width='25.1898'
      height='51.3126'
      fill='white'
      stroke='#464646'
      strokeWidth='4.66478'
    />
    <rect
      x='238.324'
      y='131.08'
      width='25.1898'
      height='72.7706'
      fill='white'
      stroke='#464646'
      strokeWidth='4.66478'
    />
    <rect
      x='264.447'
      y='105.89'
      width='25.1898'
      height='97.9604'
      fill='white'
      stroke='#464646'
      strokeWidth='4.66478'
    />
    <path
      d='M205.205 125.483H155.292V177.728L210.336 204.317H311.095'
      stroke='#464646'
      strokeWidth='4.66478'
      strokeLinecap='round'
    />
    <circle
      cx='117.973'
      cy='132.013'
      r='59.7092'
      fill='white'
      stroke='#464646'
      strokeWidth='4.66478'
    />
    <circle
      cx='221.065'
      cy='48.5137'
      r='46.1813'
      fill='white'
      stroke='#464646'
      strokeWidth='4.66478'
    />
    <circle cx='221.065' cy='48.5136' r='23.7904' stroke='#464646' strokeWidth='4.66478' />
    <line
      x1='221.531'
      y1='22.3909'
      x2='221.531'
      y2='1.86583'
      stroke='#464646'
      strokeWidth='4.66478'
    />
    <line
      x1='263.611'
      y1='60.7439'
      x2='243.785'
      y2='55.4316'
      stroke='#464646'
      strokeWidth='4.66478'
    />
    <line
      x1='242.476'
      y1='88.8663'
      x2='232.113'
      y2='71.1494'
      stroke='#464646'
      strokeWidth='4.66478'
    />
    <path
      d='M83.9202 155.373C88.585 145.075 76.4566 140.41 67.127 147.442L26.145 181.869C26.0997 181.907 26.0509 181.941 25.9993 181.97L2.85645 194.876C2.32862 195.171 2.21569 195.882 2.62631 196.325L48.3373 245.691C48.6727 246.053 49.2321 246.092 49.6137 245.778L66.9824 231.527C67.0779 231.449 67.1879 231.39 67.3062 231.355L99.3944 221.728C99.6408 221.654 99.8457 221.482 99.9608 221.252L109.397 202.38C109.512 202.15 109.716 201.978 109.961 201.904L145.029 191.291C157.624 187.524 154.358 174.498 139.431 174.498H75.6503C74.9528 174.498 74.5019 173.761 74.8199 173.14L83.9202 155.373Z'
      fill='white'
      stroke='#464646'
      strokeWidth='4.66478'
      strokeLinecap='round'
    />
    <line
      x1='24.0616'
      y1='185.012'
      x2='66.9776'
      y2='231.66'
      stroke='#464646'
      strokeWidth='4.66478'
    />
    <path
      d='M119.369 167.299H115.208V95.426H119.369V167.299ZM117.402 160.944C113.367 160.944 110.114 159.658 107.643 157.085C105.196 154.513 103.973 151.134 103.973 146.948V145.056H109.648V146.948C109.648 149.444 110.354 151.462 111.766 153C113.178 154.513 115.057 155.27 117.402 155.27C119.748 155.27 121.626 154.513 123.039 153C124.451 151.462 125.157 149.444 125.157 146.948V142.711C125.157 141.324 125.107 140.227 125.006 139.42C124.905 138.588 124.627 137.919 124.173 137.415C123.745 136.911 122.988 136.444 121.904 136.015C120.845 135.561 119.344 135.019 117.402 134.389C114.048 133.279 111.451 132.359 109.61 131.627C107.769 130.896 106.445 130.114 105.638 129.282C104.856 128.45 104.377 127.353 104.2 125.991C104.049 124.604 103.973 122.738 103.973 120.392V115.777C103.973 111.566 105.196 108.187 107.643 105.64C110.114 103.067 113.367 101.781 117.402 101.781C121.462 101.781 124.716 103.067 127.162 105.64C129.608 108.187 130.831 111.566 130.831 115.777V117.669H125.157V115.777C125.157 113.281 124.451 111.276 123.039 109.763C121.626 108.224 119.748 107.455 117.402 107.455C115.057 107.455 113.178 108.224 111.766 109.763C110.354 111.276 109.648 113.281 109.648 115.777V120.392C109.648 121.779 109.698 122.889 109.799 123.721C109.9 124.528 110.177 125.184 110.631 125.688C111.085 126.167 111.842 126.634 112.901 127.088C113.96 127.542 115.46 128.084 117.402 128.715C120.756 129.799 123.354 130.719 125.195 131.476C127.036 132.207 128.347 132.989 129.129 133.821C129.936 134.654 130.415 135.751 130.566 137.112C130.743 138.474 130.831 140.34 130.831 142.711V146.948C130.831 151.134 129.608 154.513 127.162 157.085C124.716 159.658 121.462 160.944 117.402 160.944Z'
      fill='#464646'
    />
  </svg>
)

export const EarnIconHIW = ({ width = '100', height = '100' }: IconProps) => (
  <svg
    width={width}
    height={height}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 5 130 120'
  >
    {' '}
    <path
      d='M70 125C103.137 125 130 98.1371 130 65C130 31.8629 103.137 5 70 5C36.8629 5 10 31.8629 10 65C10 98.1371 36.8629 125 70 125Z'
      fill='#EEFBFF'
    ></path>{' '}
    <path
      d='M44.2972 25.1432L39.1298 26.6827C35.9452 27.6319 32.5688 27.6319 29.3842 26.6827L25.2711 25.4578C24.1774 25.0499 22.9547 25.3482 22.1854 26.0469C21.3775 26.7806 20.9624 28.0116 21.3019 29.1894C22.4691 32.5427 24.2162 35.8791 24.6787 38.9853C22.2799 39.6882 20.5054 41.9135 20.5054 44.5275C20.5054 46.3592 21.378 48.0003 22.7242 49.0623C22.0094 51.4942 20.4949 54.8414 17.1988 58.1285C10.7228 64.587 3.42704e-06 71.9752 0 89.3133C0 107.192 14.2971 121 34.2704 121C41.1187 121 47.3011 119.404 52.4699 116.562C53.3005 116.106 53.6033 115.063 53.1459 114.233C52.6899 113.402 51.6464 113.099 50.8166 113.557C46.1828 116.105 40.5869 117.573 34.2704 117.573C15.8431 117.573 3.42704 105.395 3.42704 89.3133C3.42704 73.3498 12.7411 67.4203 19.6218 60.5582C23.2636 56.9263 25.0438 53.1467 25.9237 50.2938C31.4394 50.3139 37.1032 50.3303 42.6171 50.2938C43.497 53.1467 45.2772 56.9263 48.919 60.5582C50.8662 62.5001 53.0187 64.3808 55.0904 66.4451C55.7604 67.1132 56.8452 67.1118 57.5134 66.4417C58.1837 65.7712 58.1823 64.6839 57.5099 64.0153C55.3382 61.8513 53.1762 59.9577 51.3419 58.1284C48.0458 54.8413 46.5313 51.4942 45.8165 49.0622C47.1627 48.0002 48.0354 46.3591 48.0354 44.5274C48.0354 41.8784 46.2126 39.6291 43.765 38.9584C44.5568 35.1157 46.0959 31.8242 47.4296 28.7108C48.2779 26.4356 45.9469 24.4402 44.2972 25.1432ZM24.8862 28.9217L28.4069 29.9692C32.2277 31.108 36.2864 31.108 40.1071 29.9692L43.6211 28.9217C42.294 31.9473 40.7489 35.2066 40.3246 38.751H28.1124C27.702 35.2207 26.2086 31.9588 24.8862 28.9217ZM26.2851 42.1781H42.2557C43.5878 42.1781 44.6084 43.1953 44.6084 44.5275C44.6084 45.8596 43.5878 46.8802 42.2557 46.8802H26.2851C24.953 46.8802 23.9324 45.8596 23.9324 44.5275C23.9324 43.1953 24.953 42.1781 26.2851 42.1781Z'
      fill='#545A5E'
    ></path>{' '}
    <path
      d='M34.2702 66.3213C33.3238 66.3213 32.5567 67.0885 32.5567 68.0348V71.6392H31.8204C28.5284 71.6392 25.8231 74.3446 25.8231 77.6365V80.5415C25.8231 83.8334 28.5284 86.5388 31.8204 86.5388H32.5567V94.581H31.8204C30.0994 94.602 29.4719 93.6842 29.2334 92.7938C29.1086 91.8558 28.247 91.1966 27.309 91.3213C26.371 91.4461 25.7117 92.3076 25.8364 93.2457C26.7593 96.6898 29.5715 98.008 32.5567 98.008V101.612C32.5567 102.559 33.3238 103.326 34.2702 103.326C35.2165 103.326 35.9837 102.559 35.9837 101.612V98.008H36.72C40.0119 98.008 42.7173 95.3026 42.7173 92.0107V89.1091C42.7173 85.8172 40.0119 83.1118 36.72 83.1118H35.9837V75.0663H36.72C38.3221 75.0477 39.1229 75.8761 39.3036 76.8568C39.4284 77.7963 40.2921 78.456 41.2314 78.3293C42.1694 78.2045 42.8286 77.343 42.7039 76.405C42.3111 73.4526 39.5977 71.3352 36.653 71.6392H35.9837V68.0348C35.9837 67.0885 35.2165 66.3213 34.2702 66.3213ZM31.8204 75.0663H32.5567V83.1118H31.8204C30.3805 83.1118 29.2501 81.9813 29.2501 80.5415V77.6365C29.2501 76.1967 30.3805 75.0663 31.8204 75.0663ZM35.9837 86.5388H36.72C38.1598 86.5388 39.2902 87.6693 39.2902 89.1091V92.0107C39.2902 93.4505 38.1598 94.581 36.72 94.581H35.9837V86.5388Z'
      fill='#545A5E'
    ></path>{' '}
    <path
      d='M59.9328 68.6238C57.551 68.6238 55.582 70.5927 55.582 72.9745V77.1445C55.582 79.5263 57.551 81.4986 59.9328 81.4986H60.1838C59.9736 82.0625 59.8524 82.6693 59.8524 83.3025V85.7121C59.8524 86.3453 59.9736 86.9522 60.1838 87.516H59.9328C57.551 87.516 55.582 89.4883 55.582 91.8701V96.0401C55.582 98.4219 57.551 100.391 59.9328 100.391H60.2005C59.9792 100.968 59.8524 101.591 59.8524 102.242V104.651C59.8524 105.284 59.9736 105.891 60.1838 106.455H59.8993C57.543 106.455 55.5921 108.406 55.5921 110.762V115.023C55.5921 117.379 57.543 119.33 59.8993 119.33H87.2688C89.6251 119.33 91.576 117.379 91.576 115.023V110.762C91.576 110.434 91.5369 110.117 91.4655 109.809C93.9308 109.392 95.8364 107.227 95.8364 104.651V102.242C95.8364 99.6542 93.9134 97.4866 91.4321 97.0843C91.5169 96.7485 91.5659 96.4001 91.5659 96.0401V91.8701C91.5659 91.5256 91.5198 91.1921 91.442 90.8694C93.9187 90.463 95.8364 88.2961 95.8364 85.7121V83.3025C95.8364 80.7186 93.9187 78.5516 91.4421 78.1452C91.5199 77.8225 91.566 77.4891 91.566 77.1445V72.9745C91.566 70.5927 89.5937 68.6238 87.2119 68.6238H59.9328ZM59.9328 72.0508H87.2119C87.7544 72.0508 88.1389 72.432 88.1389 72.9745V77.1445C88.1389 77.687 87.7544 78.0716 87.2119 78.0716H59.9328C59.3902 78.0716 59.0091 77.687 59.0091 77.1445V72.9745C59.0091 72.432 59.3902 72.0508 59.9328 72.0508ZM65.0834 81.4986H90.6054C91.6354 81.4986 92.4093 82.2726 92.4093 83.3025V85.7121C92.4093 86.742 91.6354 87.516 90.6054 87.516C82.0981 87.516 73.5907 87.516 65.0834 87.516C64.0535 87.516 63.2795 86.742 63.2795 85.7121V83.3025C63.2795 82.2726 64.0535 81.4986 65.0834 81.4986ZM59.9328 90.9431H87.2119C87.7544 90.9431 88.1389 91.3276 88.1389 91.8701V96.0401C88.1389 96.5826 87.7544 96.9638 87.2119 96.9638H59.9328C59.3902 96.9638 59.0091 96.5826 59.0091 96.0401V91.8701C59.0091 91.3276 59.3902 90.9431 59.9328 90.9431ZM65.0834 100.438H90.6054C91.6354 100.438 92.4093 101.212 92.4093 102.242V104.651C92.4093 105.681 91.6354 106.458 90.6054 106.458C82.0881 106.454 73.5706 106.455 65.0499 106.455C64.0372 106.438 63.2795 105.67 63.2795 104.651V102.242C63.2795 101.212 64.0535 100.438 65.0834 100.438ZM59.8993 109.882C69.0347 109.886 78.1673 109.886 87.3056 109.886C87.8024 109.903 88.149 110.258 88.149 110.762V115.023C88.149 115.54 87.7858 115.903 87.2688 115.903H59.8993C59.3823 115.903 59.0191 115.54 59.0191 115.023V110.762C59.0191 110.245 59.3823 109.882 59.8993 109.882Z'
      fill='#545A5E'
    ></path>{' '}
    <path
      d='M66.7065 43.9618C66.4759 43.9618 66.2476 44.0083 66.0354 44.0986C65.8232 44.1889 65.6314 44.3211 65.4715 44.4872L60.341 49.8186C60.0265 50.1455 59.8544 50.5838 59.8626 51.0374C59.8707 51.491 60.0584 51.9228 60.3845 52.2382C60.5465 52.3945 60.7376 52.5173 60.9471 52.5997C61.1565 52.6821 61.3801 52.7224 61.6051 52.7183C61.8301 52.7143 62.0521 52.666 62.2584 52.5761C62.4647 52.4863 62.6513 52.3567 62.8076 52.1947L64.9929 49.9256V61.2275C64.9929 61.682 65.1735 62.1178 65.4948 62.4392C65.8162 62.7605 66.252 62.941 66.7065 62.941C67.1609 62.941 67.5968 62.7605 67.9181 62.4392C68.2395 62.1178 68.42 61.682 68.42 61.2275V49.9256L70.6054 52.1947C70.7616 52.3567 70.9482 52.4863 71.1546 52.5761C71.3609 52.666 71.5829 52.7143 71.8079 52.7183C72.0329 52.7224 72.2565 52.6821 72.4659 52.5997C72.6753 52.5173 72.8665 52.3945 73.0284 52.2382C73.3545 51.9228 73.5422 51.491 73.5504 51.0374C73.5586 50.5838 73.3865 50.1455 73.072 49.8185L67.9414 44.4872C67.7815 44.3211 67.5897 44.1889 67.3775 44.0986C67.1653 44.0083 66.9371 43.9618 66.7065 43.9618Z'
      fill='#545A5E'
    ></path>{' '}
    <path
      d='M83.8422 43.9618C83.6116 43.9618 83.3834 44.0083 83.1712 44.0986C82.959 44.1889 82.7672 44.3211 82.6073 44.4872L77.4767 49.8186C77.1622 50.1455 76.9902 50.5838 76.9983 51.0374C77.0065 51.491 77.1942 51.9228 77.5203 52.2382C77.6822 52.3945 77.8734 52.5173 78.0828 52.5997C78.2922 52.6821 78.5158 52.7224 78.7408 52.7183C78.9658 52.7143 79.1878 52.666 79.3941 52.5761C79.6005 52.4863 79.7871 52.3567 79.9433 52.1947L82.1287 49.9256V61.0267C82.1287 61.9731 82.8959 62.7402 83.8422 62.7402C84.7886 62.7402 85.5557 61.9731 85.5557 61.0267V49.9256L87.7411 52.1947C87.8974 52.3567 88.084 52.4863 88.2903 52.5761C88.4966 52.666 88.7187 52.7143 88.9437 52.7183C89.1687 52.7224 89.3922 52.6821 89.6017 52.5997C89.8111 52.5173 90.0022 52.3945 90.1642 52.2382C90.4903 51.9228 90.678 51.491 90.6861 51.0374C90.6943 50.5838 90.5222 50.1455 90.2077 49.8185L85.0772 44.4872C84.9173 44.3211 84.7255 44.1889 84.5133 44.0986C84.3011 44.0083 84.0728 43.9618 83.8422 43.9618Z'
      fill='#545A5E'
    ></path>{' '}
  </svg>
)

export const RedeemIconHIW_v0 = ({ width = '100', height = '100', classes }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 400 300'
    className={concatClassName(classes)}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='139.5' cy='123.5' r='123.5' fill='#FFEFEF' />
    <path
      d='M70.6278 54.4248C63.0771 56.861 58.0305 57.9445 49.3055 58.972C48.107 59.1132 47.4669 60.466 48.1292 61.4747L64.1701 85.9063C49.0123 82.5877 16.8672 101.512 9.54839 203.76C9.54839 203.76 8.74115 213.178 4.70508 219.635C0.669017 226.093 9.54841 228.515 12.5082 225.824C15.468 223.133 21.9257 219.44 23.8092 219.635C25.6928 219.83 49.7363 226.362 73.63 226.362'
      stroke='#464646'
      strokeWidth='5.38145'
      strokeLinecap='round'
    />
    <path
      d='M71.4775 53.8866C78.9516 51.1461 88.8108 43.0561 98.488 42.7674C99.6126 42.7339 100.271 43.9253 99.768 44.9316L79.0116 86.4445C94.1693 83.1259 126.314 102.051 133.633 204.298C133.633 204.298 134.44 213.716 138.477 220.173C142.513 226.631 133.633 229.053 130.673 226.362C127.714 223.671 121.256 219.979 119.372 220.173C117.489 220.368 95.3712 226.362 71.4775 226.362'
      stroke='#464646'
      strokeWidth='5.38145'
      strokeLinecap='round'
    />
    <rect
      x='55.3331'
      y='78.815'
      width='31.7505'
      height='9.68661'
      rx='2.69072'
      fill='white'
      stroke='#464646'
      strokeWidth='5.38145'
    />
    <circle
      cx='71.4773'
      cy='159.537'
      r='37.132'
      fill='white'
      stroke='#464646'
      strokeWidth='5.38145'
    />
    <path
      d='M71.4773 139.649L77.82 149.209L78.3743 150.044L79.3401 150.313L90.3918 153.391L83.2601 162.377L82.6368 163.163L82.6794 164.165L83.1671 175.626L72.4168 171.621L71.4773 171.271L70.5378 171.621L59.7876 175.626L60.2752 164.165L60.3178 163.163L59.6946 162.377L52.5629 153.391L63.6145 150.313L64.5804 150.044L65.1347 149.209L71.4773 139.649Z'
      stroke='#464646'
      strokeWidth='5.38145'
    />
    <rect
      x='102.278'
      y='108.374'
      width='206.17'
      height='103.194'
      transform='rotate(2.95508 102.278 108.374)'
      fill='white'
      stroke='#464646'
      strokeWidth='5.38145'
    />
    <circle
      cx='205.676'
      cy='175.343'
      r='35.9308'
      transform='rotate(2.95508 205.676 175.343)'
      fill='white'
      stroke='#464646'
      strokeWidth='5.38145'
    />
    <path
      d='M191.786 191.661L216.829 156.387L220.192 157.083L195.148 192.357L191.786 191.661ZM196.974 170.754C195.095 170.365 193.699 169.465 192.786 168.054C191.894 166.629 191.646 164.959 192.042 163.045L193.192 157.485C193.588 155.571 194.477 154.145 195.857 153.208C197.258 152.258 198.899 151.977 200.778 152.366C202.658 152.754 204.043 153.661 204.935 155.086C205.848 156.498 206.106 158.161 205.71 160.074L204.56 165.635C204.164 167.549 203.265 168.981 201.864 169.932C200.483 170.869 198.853 171.143 196.974 170.754ZM197.605 167.702C198.554 167.899 199.377 167.745 200.074 167.242C200.789 166.743 201.249 165.993 201.456 164.993L202.607 159.432C202.813 158.432 202.688 157.561 202.23 156.819C201.772 156.077 201.078 155.61 200.147 155.417C199.199 155.221 198.358 155.371 197.627 155.867C196.912 156.366 196.451 157.116 196.244 158.116L195.094 163.677C194.887 164.677 195.012 165.548 195.47 166.29C195.945 167.035 196.657 167.506 197.605 167.702ZM211.173 196.373C209.311 195.988 207.924 195.09 207.011 193.678C206.119 192.253 205.871 190.584 206.267 188.67L207.417 183.109C207.813 181.196 208.702 179.77 210.082 178.833C211.483 177.882 213.115 177.6 214.977 177.985C216.857 178.374 218.242 179.281 219.134 180.706C220.047 182.117 220.305 183.78 219.909 185.694L218.759 191.254C218.363 193.168 217.464 194.6 216.063 195.551C214.682 196.488 213.052 196.762 211.173 196.373ZM211.804 193.322C212.753 193.518 213.584 193.366 214.299 192.867C215.014 192.367 215.474 191.618 215.681 190.618L216.832 185.057C217.038 184.057 216.913 183.186 216.455 182.444C215.997 181.702 215.303 181.235 214.372 181.042C213.406 180.842 212.566 180.992 211.852 181.492C211.137 181.991 210.676 182.741 210.469 183.741L209.319 189.301C209.112 190.301 209.237 191.172 209.695 191.914C210.153 192.656 210.856 193.125 211.804 193.322Z'
      fill='#464646'
    />
    <rect
      x='66.3724'
      y='100.172'
      width='206.17'
      height='103.194'
      transform='rotate(-22.1059 66.3724 100.172)'
      fill='white'
      stroke='#464646'
      strokeWidth='5.38145'
    />
    <circle
      cx='179.913'
      cy='113.214'
      r='35.9308'
      transform='rotate(-22.1059 179.913 113.214)'
      fill='white'
      stroke='#464646'
      strokeWidth='5.38145'
    />
    <path
      d='M188.985 133.238L186.585 134.212L169.748 92.7597L172.148 91.7849L188.985 133.238ZM186.362 130.033C184.034 130.978 181.857 130.999 179.829 130.094C177.815 129.184 176.318 127.521 175.338 125.107L174.895 124.016L178.167 122.687L178.61 123.777C179.195 125.217 180.075 126.215 181.25 126.772C182.419 127.314 183.68 127.31 185.032 126.761C186.385 126.211 187.291 125.335 187.751 124.131C188.206 122.913 188.14 121.584 187.555 120.144L186.563 117.701C186.238 116.901 185.952 116.28 185.705 115.838C185.451 115.382 185.135 115.061 184.755 114.877C184.389 114.686 183.844 114.594 183.118 114.601C182.401 114.587 181.408 114.626 180.141 114.717C177.946 114.863 176.233 114.941 174.999 114.95C173.766 114.96 172.82 114.819 172.159 114.528C171.513 114.231 170.98 113.711 170.559 112.967C170.147 112.202 169.666 111.144 169.117 109.791L168.036 107.129C167.049 104.7 166.963 102.465 167.777 100.423C168.6 98.3601 170.175 96.8562 172.502 95.911C174.844 94.9598 177.021 94.9395 179.035 95.85C181.042 96.746 182.539 98.4085 183.526 100.837L183.969 101.928L180.696 103.258L180.253 102.167C179.668 100.727 178.791 99.7359 177.623 99.194C176.448 98.6376 175.184 98.6342 173.831 99.1836C172.479 99.733 171.575 100.617 171.121 101.835C170.661 103.038 170.723 104.36 171.308 105.8L172.389 108.462C172.714 109.262 173.003 109.89 173.256 110.346C173.504 110.788 173.817 111.101 174.197 111.286C174.571 111.456 175.117 111.548 175.834 111.561C176.551 111.575 177.544 111.536 178.811 111.445C181 111.285 182.714 111.207 183.953 111.212C185.186 111.203 186.125 111.346 186.771 111.643C187.431 111.934 187.965 112.454 188.371 113.204C188.792 113.948 189.28 115.004 189.835 116.371L190.828 118.815C191.809 121.229 191.895 123.465 191.087 125.521C190.278 127.578 188.703 129.082 186.362 130.033Z'
      fill='#464646'
    />
  </svg>
)

export const RedeemIconHIW = ({ width = '100', height = '100' }: IconProps) => (
  <svg
    width={width}
    height={height}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 5 130 120'
  >
    {' '}
    <path
      d='M70 125C103.137 125 130 98.1371 130 65C130 31.8629 103.137 5 70 5C36.8629 5 10 31.8629 10 65C10 98.1371 36.8629 125 70 125Z'
      fill='#EEFBFF'
    ></path>{' '}
    <path
      d='M87.2251 36.0969C87.2251 34.2467 85.7204 32.7421 83.8702 32.7421H75.4831V29.7951C75.4831 24.9455 71.5377 21.0001 66.6898 21.0001C64.3399 21.0001 62.1309 21.9142 60.4715 23.5769L51.9992 32.0475L43.5286 23.5769C41.8676 21.9142 39.6602 21.0001 37.3087 21.0001C32.4607 21.0001 28.5154 24.9455 28.5154 29.7951V32.7421H20.1283C18.278 32.7421 16.7734 34.2467 16.7734 36.0969V42.8066C16.7734 44.6568 18.278 46.1614 20.1283 46.1614H83.8702C85.7204 46.1614 87.2251 44.6568 87.2251 42.8066V36.0969ZM62.8451 25.9472C63.8706 24.9201 65.236 24.355 66.6898 24.355C69.6891 24.355 72.1283 26.7957 72.1283 29.7951V32.7421H56.0486L62.8451 25.9472ZM53.6767 36.0969V42.8066H50.3218V36.0969H53.6767ZM31.8702 29.7951C31.8702 26.7957 34.3093 24.355 37.3087 24.355C38.7625 24.355 40.1279 24.9201 41.155 25.9488L47.9498 32.7421H31.8702V29.7951ZM20.1283 36.0969H46.967V42.8066H20.1283V36.0969ZM57.0315 42.8066V36.0969H83.8702L83.8718 42.8066H57.0315Z'
      fill='#545A5E'
    ></path>{' '}
    <path
      d='M20.1279 125H83.8699V89.7745H20.1279V125ZM50.3215 121.646V93.1294H53.6763V121.646H50.3215ZM80.515 121.646H57.0312V93.1294H80.515V121.646ZM23.4828 93.1294H46.9666V121.646H23.4828V93.1294Z'
      fill='#545A5E'
    ></path>{' '}
    <path d='M60.3877 114.936H63.7425V118.291H60.3877V114.936Z' fill='#545A5E'></path>{' '}
    <path d='M67.0967 114.936H70.4515V118.291H67.0967V114.936Z' fill='#545A5E'></path>{' '}
    <path d='M73.8057 114.936H77.1605V118.291H73.8057V114.936Z' fill='#545A5E'></path>{' '}
    <path
      d='M48.6446 61.2581H55.3542C56.2798 61.2581 57.0317 62.0116 57.0317 62.9355H60.3865C60.3865 60.1614 58.1284 57.9032 55.3542 57.9032H53.6768V56.2258H50.322V57.9032H48.6446C45.8704 57.9032 43.6123 60.1614 43.6123 62.9355V64.6129C43.6123 67.3871 45.8704 69.6452 48.6446 69.6452H55.3542C56.2798 69.6452 57.0317 70.3987 57.0317 71.3226V73C57.0317 73.9239 56.2798 74.6774 55.3542 74.6774H48.6446C47.719 74.6774 46.9671 73.9239 46.9671 73H43.6123C43.6123 75.7742 45.8704 78.0323 48.6446 78.0323H50.322V79.7097H53.6768V78.0323H55.3542C58.1284 78.0323 60.3865 75.7742 60.3865 73V71.3226C60.3865 68.5485 58.1284 66.2903 55.3542 66.2903H48.6446C47.719 66.2903 46.9671 65.5368 46.9671 64.6129V62.9355C46.9671 62.0116 47.719 61.2581 48.6446 61.2581Z'
      fill='#545A5E'
    ></path>{' '}
    <path
      d='M37.717 56.2915C35.0297 59.5759 33.5488 63.7228 33.5488 67.9679C33.5488 78.1414 41.827 86.4195 52.0004 86.4195C56.2456 86.4195 60.3925 84.9403 63.6769 82.253L61.5498 79.6558C58.8657 81.8533 55.4724 83.0647 52.0004 83.0647C43.6756 83.0647 36.9037 76.2911 36.9037 67.9679C36.9037 64.496 38.115 61.1026 40.3126 58.4169L37.717 56.2915Z'
      fill='#545A5E'
    ></path>{' '}
    <path
      d='M66.2831 79.6445C68.9704 76.3601 70.4513 72.2132 70.4513 67.9681C70.4513 57.7946 62.1731 49.5165 51.9997 49.5165C47.7545 49.5165 43.6076 50.9957 40.3232 53.683L42.4503 56.2802C45.1344 54.0827 48.5277 52.8713 51.9997 52.8713C60.3245 52.8713 67.0964 59.6449 67.0964 67.9681C67.0964 71.4401 65.885 74.8334 63.6875 77.5191L66.2831 79.6445Z'
      fill='#545A5E'
    ></path>{' '}
    <path d='M6.70898 49.5165H10.0638V52.8713H6.70898V49.5165Z' fill='#545A5E'></path>{' '}
    <path d='M6.70898 56.2258H10.0638V76.3549H6.70898V56.2258Z' fill='#545A5E'></path>{' '}
    <path d='M13.4189 83.0645H16.7738V86.4193H13.4189V83.0645Z' fill='#545A5E'></path>{' '}
    <path d='M13.4189 59.5808H16.7738V79.7098H13.4189V59.5808Z' fill='#545A5E'></path>{' '}
    <path d='M87.2266 83.0645H90.5814V86.4193H87.2266V83.0645Z' fill='#545A5E'></path>{' '}
    <path d='M87.2266 59.5808H90.5814V79.7098H87.2266V59.5808Z' fill='#545A5E'></path>{' '}
    <path d='M93.9346 49.5165H97.2894V52.8713H93.9346V49.5165Z' fill='#545A5E'></path>{' '}
    <path d='M93.9346 56.2258H97.2894V76.3549H93.9346V56.2258Z' fill='#545A5E'></path>{' '}
    <path d='M100.646 41.1292H104V44.484H100.646V41.1292Z' fill='#545A5E'></path>{' '}
    <path d='M100.646 47.8387H104V67.9678H100.646V47.8387Z' fill='#545A5E'></path>{' '}
    <path d='M0 41.1292H3.35484V44.484H0V41.1292Z' fill='#545A5E'></path>{' '}
    <path d='M0 47.8387H3.35484V67.9678H0V47.8387Z' fill='#545A5E'></path>{' '}
  </svg>
)

export const BackedByGlobalInstituitions = () => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      style={{ color: '#1D599F' }}
    >
      {/* Shield */}
      <path d='M12 2l7 4v6c0 5-3.5 9-7 10-3.5-1-7-5-7-10V6l7-4z' />

      {/* Checkmark */}
      <path d='M9 12l2 2 4-4' />
    </svg>
  )
}

export const LicensedByExperts = () => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      style={{ color: '#1D599F' }}
    >
      <circle cx='12' cy='8' r='6' />
      <path d='M9 14l-1 7 4-2 4 2-1-7' />
      <path d='M12 5v6' />
      <path d='M9 8h6' />
    </svg>
  )
}

export const AssetSecurity = () => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      style={{ color: '#1D599F' }}
    >
      <rect x='3' y='11' width='18' height='10' rx='2' />
      <path d='M7 11V7a5 5 0 0 1 10 0v4' />
      <circle cx='12' cy='16' r='1' />
    </svg>
  )
}
